import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateTaxRate($companyId: ID!, $id: ID!, $attributes: TaxRateAttributes!) {
    updateTaxRate(companyId: $companyId, id: $id, attributes: $attributes) {
      taxRate {
        id
        ...UpdatedTaxRate
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedTaxRate on TaxRate {
    id
    name
    rate
  }
`
